"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MissingPage = exports.MissingPageConfig = void 0;
const theme_1 = require("../components/theme");
const i18n_1 = require("../i18n");
const mithril_1 = require("../mithril");
const services_1 = require("../services");
const page_1 = require("./page");
const CSS = {
    container: 'c-Missing',
    left: 'c-Missing__Left',
    right: 'c-Missing__Right',
    errorName: 'c-Missing__Error-Name',
    errorDescription: 'c-Missing__Error-Description',
};
const Style = {
    [CSS.container]: {
        width: '100%',
        height: '100%',
        display: 'flex',
        'justify-content': 'center',
        'align-items': 'center',
        'background-color': theme_1.DefaultTheme.background.darkGrey,
    },
    [CSS.left]: {
        'justify-content': 'center',
        'align-items': 'center',
        'margin-right': theme_1.DefaultTheme.space(14),
        'font-size': '112px',
        color: theme_1.DefaultTheme.color.accent,
    },
    [CSS.right]: {
        color: theme_1.DefaultTheme.background.offWhite,
    },
    [CSS.errorName]: {
        'font-size': theme_1.DefaultTheme.space(21),
        'margin-bottom': theme_1.DefaultTheme.space(12),
        'line-height': 1,
    },
    [CSS.errorDescription]: {
        'font-size': theme_1.DefaultTheme.space(5),
    },
};
(0, theme_1.addStyles)(Style);
// todo: we could use Proxy once we get rid of IE :)
const MissingErrors = {
    404: {
        errorCode: i18n_1.T.MISSING_404_CODE,
        errorTitle: i18n_1.T.MISSING_404_TITLE,
        errorBeforeLink: i18n_1.T.MISSING_404_BEFORE_LINK,
        errorLinkText: i18n_1.T.MISSING_404_LINK,
        errorAfterLink: i18n_1.T.MISSING_404_AFTER_LINK,
    },
    403: {
        errorCode: i18n_1.T.MISSING_403_CODE,
        errorTitle: i18n_1.T.MISSING_403_TITLE,
        errorBeforeLink: i18n_1.T.MISSING_404_BEFORE_LINK,
        errorLinkText: i18n_1.T.MISSING_403_LINK,
        errorAfterLink: i18n_1.T.MISSING_404_AFTER_LINK,
    },
};
exports.MissingPageConfig = {
    type: 'internal',
    name: page_1.IkePageName.pageMissing,
    path: '/error',
    auth: {
        required: false,
    },
    layout: { nav: false },
};
class MissingPage extends page_1.IkePage {
    constructor(errorType = 404) {
        super(exports.MissingPageConfig);
        this.errorType = errorType;
        // If the user is not authenticated, then we dont want to show the top bar
        if (!services_1.Services.User.isAuthenticated) {
            this.config.layout = { banner: false };
        }
    }
    get nodes() {
        return (0, mithril_1.m)('div', { className: CSS.container }, [
            (0, mithril_1.m)('div', { className: CSS.left }, (0, i18n_1.Translate)(MissingErrors[this.errorType].errorCode)),
            (0, mithril_1.m)('div', { className: CSS.right }, [
                (0, mithril_1.m)('div', { className: CSS.errorName }, (0, i18n_1.Translate)(MissingErrors[this.errorType].errorTitle)),
                (0, mithril_1.m)('div', { className: CSS.errorDescription }, [
                    (0, mithril_1.m)('span', (0, i18n_1.Translate)(MissingErrors[this.errorType].errorBeforeLink)),
                    (0, mithril_1.m)('a', { href: services_1.Services.User.isAuthenticated ? '/#/map' : '/#/login' }, (0, i18n_1.Translate)(MissingErrors[this.errorType].errorLinkText)),
                    (0, mithril_1.m)('span', (0, i18n_1.Translate)(MissingErrors[this.errorType].errorAfterLink)),
                ]),
            ]),
        ]);
    }
}
exports.MissingPage = MissingPage;
//# sourceMappingURL=missing.page.js.map